import React from 'react';

interface LabelValuePair {
    label: string;
    value: string;
}

const formatLabelAsKey = (label: string) => {
    if (!label) {
        return '';
    } else {
        return label.trim().replaceAll(' ', '-').replaceAll(':', '').toLowerCase();
    }
}

interface StyledListProps {
    labelValuePairs: LabelValuePair[];
    dataTestId?: string;
}

const StyledList = ({
    labelValuePairs,
    dataTestId = '',
}: StyledListProps) => {
    return (
        <ul className="list">
            {labelValuePairs.map((lv, i) => (
                <>
                    <br />
                    <li
                        className="list__item"
                        key={`${lv.label}`}
                        style={{ display: 'block' }}
                        data-testid={dataTestId ? `${dataTestId}_item-${formatLabelAsKey(lv.label)}` : null}
                    >
                        <span 
                            className="list__item-name" 
                            style={{ 
                                display: 'inline-block', 
                                float: 'left', 
                            }}
                        >
                            {lv.label}
                        </span>
                        <span 
                            className="list__item-value" 
                            style={{ 
                                display: 'inline-block', 
                                float: 'right', 
                            }}
                        >
                            {lv.value}
                        </span>
                    </li>
                </>
            ))}
        </ul>
    );
};

export default StyledList;
